/**
 * הודעת שגיאת שדה — DESIGN.md 4.6: "שגיאה מתחת לשדה, --color-danger, עם
 * אייקון + טקסט (לא צבע בלבד), role='alert'".
 */
import type { ReactNode } from 'react';
import { WarningCircle } from '@phosphor-icons/react';

interface FieldErrorProps {
  id?: string;
  children: ReactNode;
}

export function FieldError({ id, children }: FieldErrorProps) {
  return (
    <p id={id} role="alert" className="text-danger mt-1 flex items-center gap-1 text-sm">
      <WarningCircle size={14} weight="regular" aria-hidden="true" className="shrink-0" />
      <span>{children}</span>
    </p>
  );
}
